import { zfUtils } from "./zf_utils";
import { zfch2 } from "./zfc_header";
import { zfcsaf } from "./zfc_search_filter";
export class zfcss {
    static init() {
        try {
            $(".zfcss_search_stage_wrapper").each(function () {
                var that = $(this);
                var id = that.attr("id");
                var autocompleteKey = 'zfcss-search-datalist-' + id;
                var searchInput = that.find(".zfch-input-search").get(0);
                zfcsaf.registerAutocompleteInput(autocompleteKey, searchInput);
                zfUtils.onReady(function () {
                    var scope = zfch2.globalSettings.hasOwnProperty("scope") ? zfch2.globalSettings.scope : 'default';
                    zfcsaf.scheduleAutocomplete(scope, autocompleteKey, 'matchall', 15, true);
                    that.find(".zfch-input-search")
                        .attr("autocomplete", "off")
                        .removeAttr("list")
                        .off("keypress.zfcss")
                        .on("keypress.zfcss", function (e) {
                        var nextValue = e.currentTarget.value + (e.key || "");
                        zfcsaf.scheduleAutocomplete(scope, autocompleteKey, nextValue, 15);
                    })
                        .off("focus.zfcss click.zfcss")
                        .on("focus.zfcss click.zfcss", function () {
                        var autocomplete = zfcsaf.autocompleteInstances[autocompleteKey];
                        if (autocomplete && typeof autocomplete.evaluate === "function") {
                            autocomplete.evaluate();
                        }
                    });
                });
            });
        }
        catch (err) {
            console.log("initalization failed: zfcss.init() " + err.message);
        }
    }
}
try {
    zfUtils.onReady(zfcss.init);
}
catch (err) {
    console.log("initalization failed: zfcss.init() " + err.message);
}
